import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import GridContainer from "components/Grid/GridContainer";
import styled from "styled-components";
import { BLUE_RGB } from "utils/colorsTheme";

export const GridCustom = styled(GridContainer)`
  position: relative;
`;
export const ButtonBackContainer = styled.div`
  display: flex;
  width: 100;
  justify-content: flex-end;
`;
export const SearchHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;
export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const AccountTitle = styled.h6`
  margin: 0;
  color: ${BLUE_RGB};
  font-weight: bold;
`;
export const ServiceBody = styled(CardBody)`
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
`;
export const AccountBody = styled(CardBody)`
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
`;
export const InputSearchContainer = styled.div``;
export const CustomerCard = styled(Card)`
  cursor: pointer;
  margin: 1rem 0;
`;
export const CustomerCardWrapper = styled(CardBody)`
  display: flex;
  align-items: center;
`;
export const CustomerTextContainer = styled.div`
  margin-left: 0.8rem;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const CustomerTitle = styled.h5`
  margin: 0 0 0.4rem;
  font-weight: bold;
  color: #3c4858;
`;
export const CustomerInfo = styled.p`
  margin-bottom: 0.3rem;
`;

export const CustomerSubtitle = styled.span`
  font-weight: bold;
  color: #999999;
`;
// Customer Info
export const InfoTitle = styled.h4`
  text-align: center;
  font-weight: bold;
  color: #3c4858;
`;
export const InfoNumber = styled.h6`
  color: #999999;
`;
export const InfoText = styled.p`
  text-align: center;
  margin-bottom: 0.4rem;
`;
export const SectionHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const CardData = styled(Card)`
  margin: 0.8rem 0;
  position: relative;
`;

export const FormContainer = styled.form`
  margin: 0.5rem 0 1.6rem;
`;
export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const styles = {
  textColorPrimary: {
    color: BLUE_RGB,
    borderColor: BLUE_RGB,
  },
};
// Customer form
export const LineStyled = styled.hr`
  border-color: ${BLUE_RGB};
  margin: 0.3rem 0;
`;
export const InputWrapper = styled.div`
  width: 240px;
  display: inline;
  height: auto;
`;
export const FormRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const FormRowAutocomplete = styled(FormRow)`
  position: relative;
`;
export const SectionTitle = styled.h6`
  margin: 10px 0 0.3rem;
`;
export const GoogleAutocompleteContainer = styled.div`
  width: 480px;
  max-width: 360;
  background-color: #333;
  color: white;
  position: absolute;
  z-index: 9997;
  left: 10px;
  top: 100%;
`;
// Acounts form
export const SelectsRow = styled.div`
  display: flex;
`;
export const SelectItem = styled.div`
  flex-grow: 1;
  margin-right: ${(props) => (props.withMargin ? "0.8rem" : "0")};
`;
export const AutoCompleteWrapper = styled.div`
  position: relative;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 0.6rem;
`;
export const CardTextStyled = styled.div`
  display: flex;
  align-items: center;
`;
export const SearchTitle = styled.h5`
  margin: 0;
  margin-left: 0.6rem;
`;
export const QuantityText = styled.span`
  display: flex;
  width: 250px;
  align-items: center;
  margin: 0 0 0 0.8rem;
  padding-top: 0.8rem;
`;
export const PriceText = styled.span`
  display: flex;
  width: 250px;
  align-items: center;
  margin: 0;
  padding-top: 0.8rem;
`;
export const CardStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 0 0 6px 0;
`;
